import { ReactFlow } from "@xyflow/react";
import styled from "styled-components";

export const StyledReactFlow = styled(ReactFlow)`
  width: 100%;
  height: 100%;
`;
